import axios from 'axios'
import FingerprintJS from '@fingerprintjs/fingerprintjs'

const IP_KEY = 'last-ip'
const IPIFY_TIMEOUT = 2500 /** milliseconds */
const MAX_APIFY_ATTEMPTS = 3
const GENERIC_IP = '192.168.0.0'

/**
 * Returns de API request from Apify
 * @param timeout milliseconds to wait for request
 * @returns an IP value
 */
const getIPFromIpify = async function (timeout: number) {
  return axios.get('https://api.ipify.org', { timeout: timeout })
}

const DeviceInfo = {
  OS: [
    { name: 'Windows Phone', value: 'Windows Phone', version: 'OS' },
    { name: 'Windows', value: 'Win', version: 'NT' },
    { name: 'iPhone', value: 'iPhone', version: 'OS' },
    { name: 'iPad', value: 'iPad', version: 'OS' },
    { name: 'Kindle', value: 'Silk', version: 'Silk' },
    { name: 'Android', value: 'Android', version: 'Android' },
    { name: 'PlayBook', value: 'PlayBook', version: 'OS' },
    { name: 'BlackBerry', value: 'BlackBerry', version: '/' },
    { name: 'Macintosh', value: 'Mac', version: 'OS X' },
    { name: 'Linux', value: 'Linux', version: 'rv' },
    { name: 'Palm', value: 'Palm', version: 'PalmOS' }
  ],
  browser: [
    { name: 'Opera', value: 'OPR', version: 'OPR' },
    { name: 'Opera', value: 'Opera', version: 'Opera' },
    { name: 'Edge', value: 'Edg', version: 'Edg' },
    { name: 'Chrome', value: 'Chrome', version: 'Chrome' },
    { name: 'Firefox', value: 'Firefox', version: 'Firefox' },
    { name: 'Safari', value: 'Safari', version: 'Version' },
    { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
    { name: 'BlackBerry', value: 'CLDC', version: 'CLDC' },
    { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' }
  ],
  init: function () {
    const agent = navigator.userAgent
    const os = this.matchItem(agent, this.OS)
    const browser = this.matchItem(agent, this.browser)
    return { os: os, browser: browser }
  },
  matchItem: function (string: string, data: any[]) {
    let regex, regexVersion, matchSystem, matchesVersion, version
    // Validates for each system (OS or browser)
    for (let i = 0; i < data.length; i += 1) {
      regex = new RegExp(data[i].value, 'i')
      matchSystem = regex.test(string)
      if (matchSystem) {
        const versionString = data[i].version + '[ -/:;+]([\\d._]+)'
        regexVersion = new RegExp(versionString, 'i')
        matchesVersion = string.match(regexVersion)
        version = ''
        // Gets the version value
        if (matchesVersion && matchesVersion[1]) {
          version = matchesVersion[1]
        } else {
          version = '0'
        }
        return {
          name: data[i].name,
          version: version
        }
      }
    }
    return { name: 'unknown', version: '0' }
  },
  /**
   * @param attempt current attempt to get the IP
   * @returns the current IP for the browser
   */
  getCurrentIP: async function (attempt: number): Promise<any> {
    const lastIP = localStorage.getItem(IP_KEY)
    let IP = lastIP
    let tryAgain = 0 // 0: ok, 1: tryAgain, 2: lastAttempt
    // if exists a previous IP storaged, we wait at most 2.5 seconds
    // else  we wait until response is resolved and update de IP
    await getIPFromIpify(lastIP ? IPIFY_TIMEOUT : 0)
      .then((response) => {
        const currentIP = response.data
        localStorage.setItem(IP_KEY, currentIP)
        IP = currentIP
      })
      .catch(() => {
        tryAgain = IP === undefined && attempt < MAX_APIFY_ATTEMPTS ? 1 : 2
      })

    if (tryAgain === 1) {
      return this.getCurrentIP(attempt + 1)
    } else if (tryAgain === 2) {
      IP = GENERIC_IP
    }
    return IP
  },
  /**
   * Generates the fingerprint for the current browser by FingerprintJS
   */
  getFingerprint: async function () {
    const fpPromise = FingerprintJS.load()
    const fingerprint = await fpPromise
      .then(fp => fp.get())
      .then(result => {
        return result.visitorId
      })
    return fingerprint
  },
  /**
   * @returns the name of the device composed of OS / Browser Name + version / IP
   */
  getBrowserName: async function () {
    const device = this.init()
    const IP = await this.getCurrentIP(1)
    return `${device.os.name} ${device.os.version} / ${device.browser.name} ${device.browser.version} / ${IP}`
  }
}

export default DeviceInfo
